module.exports = __webpack_public_path__ + "static/img/2856.a71f709.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/13/2856.jpg
// module id = 700
// module chunks = 0